module.exports = __webpack_public_path__ + "workspace/static/img/nfrServicesTwo.a82c9b7.png";